import { httpPost, httpDownloadData } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getBillStatFile(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/excel/getBillStatFile`;
    return httpDownloadData(apiUrl, data);
  }

  getCheckoutStatFile(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/excel/getCheckoutStatFile`;
    return httpDownloadData(apiUrl, data);
  }

  getBillStatFileByQueue(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/excel/getBillStatFile/queue`;
    return httpPost(apiUrl, data);
  }

  getBillStatFileLink() {
    // let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
    //   "CLINIC"
    // )}/excel/getBillStatFile`;
    // return httpPost(apiUrl, data);
  }
}
